import { useOutletContext } from "react-router-dom";
import { useEffect } from "react";
import ExpandableTextMobile from "../components/ExpandableText";

const Support = () => {
  const { setPageTitle } = useOutletContext();

  useEffect(() => {
    setPageTitle("Support");
  }, [setPageTitle]);

  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;

    const companyStr = localStorage.getItem("company");
  const company = companyStr ? JSON.parse(companyStr) : null;

  return (
    <div className="container py-2">
      
      {/* Logo */}
      <div className="text-center mb-md-2">
       
          <img
            src={customer?.company_image || company?.cmp_image || "/default_company_logo.png"}
            alt="Company Logo"
            className="img-fluid"
            style={{ maxHeight: "100px" }}
          />
        
      </div>

      {/* Company Name */}
      <h4 className="text-center fw-bold mb-2 text-theme">
      NPRO Software Solutions 
      </h4>

      {/* Heading */}
      <h5 className="text-center text-white mb-md-4">
        Contact Us
      </h5>

      {/* Contact Card */}
      <div className="row justify-content-center">
  <div className="col-12 col-md-8 col-lg-8">
    <div className="card company-selected-card ">
      <div className="card-body">

          <p ><i className="fa-solid fa-phone me-3 text-theme"></i> <span className="support-label">+919527588822</span></p>

          <p ><i className="fa-solid fa-phone me-3 text-theme"></i> <span className="support-label">+919527588822</span></p>

          <p >
          <i className="fa-brands fa-whatsapp me-3 text-theme"></i>
          
          <span className="support-label">
                +919527588822
              </span>
          
          </p>

          <p >
          <i className="fa-solid fa-envelope me-3 text-theme"></i>
           
              <a href={`mailto:nisanandroid@gmail.com`} className="support-label">
              nisanandroid@gmail.com
              </a>
           
          </p>

          <p >
          <i className="fa-solid fa-globe me-3 text-theme"></i>
            
              <a
                href="https://nproindia.com"
                target="_blank"
                rel="noopener noreferrer"
                className="support-label"
              >
               https://nproindia.com
              </a>
           
          </p>

          <p >
          <i className="fa-solid fa-location-dot me-3 text-theme mt-1"></i>
            <span className="support-label"> 
            <ExpandableTextMobile 
              text="PLOT NO. 79/1, S BLOCK, Gala No - 36, PESH INDUSTRIAL PREMISES, NEAR CENTURY ENKA COLONY, 
              TELCO ROAD, LANDEWADI, BHOSARI-MIDC, PIN - 411026,PIMPRI CHINCHWAD, 
              DIST - PUNE (MAHARASHTRA) GSTN: 27AOZPS9137H1ZX"
              maxLength={30}
              className="long-main-card-text mb-1"
              
            />
            </span>
          </p>

          </div>
    </div>
  </div>
</div>
<div className="text-center mt-4">
                  <small className="text-white">© 2026 NPRO Software Solutions Pvt Ltd</small>
                </div>
</div>
  );
};

export default Support;